// React
import { Component, createElement } from 'react'
import PropTypes from 'prop-types'
import { connect as reduxConnect } from 'react-redux'

// Libraries

// Components

// Shared
import { triggerUserFrameworkBookEvent } from 'shared/utils/userFrameworkEvents'
import cartActions from 'store/v2/redux/actions/cart'

export class EmbeddableCartLineContainer extends Component {
  static displayName = 'EmbeddableCartLineContainer'

  static propTypes = {
    book: PropTypes.func,
    line: PropTypes.object,
    component: PropTypes.any.isRequired
  }

  constructor (props) {
    super(props)

    this.state = {
      quantity: props.line.quantity,
      deleting: false
    }
  }

  handleBook = (quantity) => {
    if (quantity === 0) {
      this.setState({ deleting: true })
    }

    if (quantity === -1) {
      return
    }

    this.setState({ quantity })

    this.props.book(quantity)
  }

  handleIncreaseQuantity = () => {
    const { quantity } = this.state

    this.handleBook(quantity + 1)
  }

  handleDecreaseQuantity = () => {
    const { quantity } = this.state

    this.handleBook(quantity - 1)
  }

  handleRemove = () => {
    this.handleBook(0)
  }

  handleInputChange = ({ target }) => {
    if (target.value) {
      this.handleBook(target.value)
    }
  }

  render () {
    const { component, ...otherProps } = this.props
    const { quantity, deleting } = this.state

    return createElement(component, {
      quantity,
      deleting,
      onIncreaseQuantity: this.handleIncreaseQuantity,
      onDecreaseQuantity: this.handleDecreaseQuantity,
      onRemove: this.handleRemove,
      onInputChange: this.handleInputChange,
      ...otherProps
    })
  }
}

const mapStateToProps = (state, props) => {
  return {
    currency: state.client.currency.toJS(),
    useAvailability: state.settings.get('store.use_availability') && props.line.tracking_type !== 'none',
    showPrices: state.settings.get('store.use_prices'),
    photo: props.line.product && state.orm.photos.getById(props.line.product.photo_id)
  }
}

const mapDispatchToProps = (_dispatch, props) => {
  return {
    book: (quantity) => {
      return cartActions.book({
        item_id: props.line.item_id,
        line_id: props.line.id,
        quantity,
        type: 'set',
        apiVersion: 1
      }).then((_response) => {
        const quantityChange = quantity - props.line.quantity

        triggerUserFrameworkBookEvent(props.line.item_id, quantityChange)
      })
    }
  }
}

export default reduxConnect(mapStateToProps, mapDispatchToProps)(EmbeddableCartLineContainer)
